import { FormControl, FormGroup, Validators } from "@angular/forms";

export class SendMessageForm extends FormGroup {

  constructor() {

    super({
      body: new FormControl<string>('', [Validators.required]),
      from: new FormControl<string>('', [Validators.required]),
      to: new FormControl<string>('', [Validators.required]),
    });

  }

}
